import React from 'react';
import cn from 'classnames';
import Popup from '../Popup/Popup';
import CTARow from '../CTARow/CTARow';
import closeModalIcon from '../../images/cross-icon.svg';
import getConfig from '../../config';

import styles from './ETFBuyModal.css';

const BuyOptions = [
    {
        title: 'Brokerage - Traditional IRA',
        subtitle: ' (Investment minimum of $1,000)',
        link: `${getConfig(
            'envDomain'
        )}/usis/nasu/start/brokerage-retirement/contributory/new/traditional`
    },
    {
        title: 'Brokerage - Roth IRA',
        subtitle: ' (Investment minimum of $1,000)',
        link: `${getConfig(
            'envDomain'
        )}/usis/nasu/start/brokerage-retirement/contributory/new/roth`
    },
    {
        title: 'Brokerage General Savings',
        subtitle: ' (Investment minimum of $2,500)',
        link: `${getConfig(
            'envDomain'
        )}/personal-investing/account-finder/all-t-rowe-price-accounts.html#brokerage`
    },
    {
        title: 'View All Brokerage Accounts',
        subtitle: '',
        link: `${getConfig(
            'envDomain'
        )}/personal-investing/account-finder/all-t-rowe-price-accounts.html#brokerage`
    }
];

const ETFBuyModal = ({ open, onClose, loggedIn, userStateLoaded }) => (
    <div className="wrapper">
        <Popup
            open={open}
            modal
            onClose={onClose}
            closeOnDocumentClick
            closeOnEscape
            className="popup"
            overlayStyle={{ overflow: 'scroll' }}
            contentStyle={{ width: '650px', overflow: 'auto' }}
        >
            {open && (
                <div className="modal">
                    <div className="header border">
                        <div className="etf-modal-title">
                            Buy ETFs online through T. Rowe Price
                        </div>
                        <div className="close-button">
                            <button onClick={() => onClose()} type="button">
                                <img
                                    src={closeModalIcon}
                                    alt="Close Buy Modal"
                                />
                            </button>
                        </div>
                    </div>
                    <div
                        className={cn('language', {
                            unblur: userStateLoaded
                        })}
                    >
                        {loggedIn ? (
                            <React.Fragment>
                                You&apos;ll need to use a T. Rowe Price
                                brokerage account to buy our ETFs. Add this ETF
                                to one of your existing brokerage accounts, or
                                open a new brokerage account type that matches
                                your financial strategy.
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                You&apos;ll need to use a brokerage account to
                                buy T. Rowe Price ETFs. Choose your account type
                                to open a new brokerage account, or{' '}
                                <a
                                    className="login-link"
                                    href={`${getConfig(
                                        'envDomain'
                                    )}/usis/login/?pdurl=/v0/ciam-public/me%3fsdurl=${getConfig(
                                        'envDomain'
                                    )}/usis/my-accounts/`}
                                >
                                    log in
                                </a>{' '}
                                to an existing account.
                            </React.Fragment>
                        )}
                    </div>
                    <div className="modal-content">
                        <CTARow BuyOptions={BuyOptions} />
                        <div className="modal-footer">
                            <p>Want to buy over the phone?</p>
                            <p className="secondary-text">
                                Call an investment specialist at{' '}
                                <a
                                    href="tel:1-800-401-4791"
                                    className="phone-num"
                                >
                                    800-401-4791
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </Popup>

        <style jsx>{styles}</style>
    </div>
);

export default ETFBuyModal;
